import * as React from 'react';
import Container from '@mui/material/Container';
import Avatar from "@mui/material/Avatar";
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import logoNamePng from "../../static/syteflow_logo_name.png";
import logoPng from "../../static/syteflow_logo_avatar.png";
import image_02 from "../../static/syteflow_screenshots/image_02.png";
import image_03 from "../../static/syteflow_screenshots/image_03.png";
import image_04 from "../../static/syteflow_screenshots/image_04.png";

import image_05 from "../../static/syteflow_screenshots/image_05.png";
import image_06 from "../../static/syteflow_screenshots/image_06.png";
import image_07 from "../../static/syteflow_screenshots/image_07.png";
import image_08 from "../../static/syteflow_screenshots/image_08.png";
import image_09 from "../../static/syteflow_screenshots/image_09.png";
import image_10 from "../../static/syteflow_screenshots/image_10.png";

import image_11 from "../../static/syteflow_screenshots/image_11.png";
import image_12 from "../../static/syteflow_screenshots/image_12.png";
import image_13 from "../../static/syteflow_screenshots/image_13.png";
import image_14 from "../../static/syteflow_screenshots/image_14.png";
import image_15 from "../../static/syteflow_screenshots/image_15.png";

import image_16 from "../../static/syteflow_screenshots/image_16.png";
import image_18 from "../../static/syteflow_screenshots/image_18.png";
import image_19 from "../../static/syteflow_screenshots/image_19.png";

import syteflowIos from "../../static/syteflow_ios_app.png";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Slider from "react-slick";
import ImageListItem from '@mui/material/ImageListItem';

const imagesCarousal = [image_02, image_03, image_06, image_07];

const imagesLabourerCarousal = [image_04, image_05, image_09, image_10];

const reportingCarousal = [image_08, image_14, image_15];

const contractorCarousal = [image_11, image_12, image_13];

const adminCarousal = [image_16, image_18, image_19];

const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: true,
    centerMode: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};


function IOSAppModal() {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
       <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 4 }}>
        <Button variant="contained" onClick={handleOpen}>Already our Customer? Download IOS app now !!!</Button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 410,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
        }}>
            <Typography variant="h3" component="h2" align="center" gutterBottom={true}>
                    Get Syteflow ios app now
            </Typography>
            <ImageListItem>
                <img
                    src={syteflowIos}
                    alt={'syteflow'}
                    loading="lazy"
                    style={{
                        objectFit: 'contain',
                    }}
                />
            </ImageListItem>
            <br/>
            <Typography variant="body1" align='center'>
                Scan the QR code with your phone camera to download the Syteflow app.
            </Typography>
            <Typography variant="body1" align='center'>
               You can also click <a target="_blank" href="https://apps.apple.com/in/app/syteflow/id6745906126">here</a> to download instead
            </Typography>
          </Box>
        </Modal>
      </Box>
    );
}

function ContactSalesModal() {
    const [open, setOpen] = React.useState(false);
  const [contactNumber, setContactNumber] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [requirement, setRequirement] = React.useState('');
  const [submitted, setSubmitted] = React.useState(false);
  const [message, setMessage] = React.useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSubmitted(false);
    setContactNumber('');
    setEmail('');
    setRequirement('');
    setMessage('');
  };
  
    const handleSubmit = async () => {
        try {
          const response = await fetch('https://syteflow.aliatis.io/contact-sales', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              contact_number: contactNumber,
              email,
              requirement
            })
          });
    
          const data = await response.json();
          setMessage(data.message || 'Thanks! Our team will reach out soon.');
          setSubmitted(true);
        } catch (error) {
          console.error('Error submitting form:', error);
          setMessage('Something went wrong. Please try again.');
          setSubmitted(true);
        }
      };
  
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 4 }}>
          <Button variant="contained" onClick={handleOpen}>
            Interested in joining us? Connect with our sales team
          </Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 410,
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
            }}>
              <Typography variant="h5" align="center" gutterBottom>
                Sales Team Contact Form
              </Typography>
    
              {!submitted ? (
                <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 4}}>
                  <TextField
                    variant="outlined"
                    label="Contact Number"
                    value={contactNumber}
                    onChange={e => setContactNumber(e.target.value)}
                    fullWidth
                    required
                    size="small"
                  />
                  <TextField
                  variant="outlined"
                    label="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    fullWidth
                    required
                    size="small"
                  />
                  <TextField
                    variant='filled'
                    label="Tell us more"
                    value={requirement}
                    onChange={e => setRequirement(e.target.value)}
                    multiline
                    required
                    rows={4}
                    fullWidth
                  />
                  <Button 
                    variant="outlined"
                    onClick={handleSubmit}
                    disabled={
                        !contactNumber.trim() ||
                        !email.trim() ||
                        !requirement.trim()
                      }
                >Submit</Button>
                </Box>
              ) : (
                <Typography variant="body1" align="center" mt={3}>{message}</Typography>
              )}
            </Box>
          </Modal>
        </Box>
      );
  }
export default function SyteFlowApp() {
    return (<div style={{ background: 'linear-gradient(to left,rgb(154, 160, 179), #003366)' }}>
        <Container id="products" sx={{
            py: { sm: 16, xs: 12 },
            color: "white"
        }} fixed>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                justifyContent: "center",
                marginBottom: 10,
                flexDirection: "column"
            }}>
                <img
                    srcSet={logoNamePng}
                    alt={"syteflow"}
                    loading="lazy"
                    style={{
                        height: 110,
                        width: 300
                    }}

                />
                <Avatar sx={{ width: 70, height: 70 }} alt="SyteFlow" src={logoPng} />
            </Box>
            <Divider style={{ marginBottom: 10 }} />
            <div style={{ padding: 10 }}>
                <Typography variant="h3" component="h2" align="left" gutterBottom={true}>
                    Overview
                </Typography>
                <Typography variant="body1" align="left">
                    <b>SyteFlow</b> is a construction site management app which is a comprehensive solution designed to streamline and digitize on-site operations. It empowers project managers and site supervisors to efficiently manage labourer attendance, wage records, inventory tracking, and supplier interactions, all in one centralized platform.
                    <br /><br />
                    The app ensures accurate and real-time recording of worker shifts and wages, minimizing errors and saving valuable time. With integrated inventory management, teams can track material usage preventing delays.
                    <br /><br />
                    Additionally, the app offers supplier tracking features to monitor deliveries and vendor performance, ensuring timely procurement. Site-level tracking provides a clear view of progress across multiple construction sites, supported by detailed reporting tools that help stakeholders make data-driven decisions. Whether managing a small project or multiple large-scale sites, this app provides the operational clarity and control needed for successful construction execution.
                </Typography>
            </div>
        </Container>
        <Box id="sites" sx={{
            pt: { xs: 4, sm: 12 },
            pb: { xs: 8, sm: 16 },
            color: 'white',
            bgcolor: 'grey.900',
        }}>
            <Container fixed className='slider-container' sx={{
                px: { sm: 15, xs: 10 },
            }}>
                <Divider style={{ marginBottom: 10 }} />
                <Typography variant="h3" component="h2" align="left" gutterBottom={true}>
                    Sites - Manage your construction sites smooothly
                </Typography>
                <Typography variant="body1" align="left">
                    Allowing to manage site Labourers Attendence and Inventory smoothly
                </Typography>
                <br />
                <Slider {...settings}>
                    {imagesCarousal.map((image: any) => (
                        <ImageListItem>
                            <img
                                src={image}
                                alt={'test'}
                                loading="lazy"
                                style={{
                                    objectFit: 'contain',
                                }}
                            />
                        </ImageListItem>))
                    }
                </Slider>
            </Container>
        </Box>

        <Box id="labourers" sx={{
            pt: { xs: 4, sm: 12 },
            pb: { xs: 8, sm: 16 },
            color: 'white',
            bgcolor: 'grey.900',
        }}>
            <Container fixed className='slider-container' sx={{
                px: { sm: 15, xs: 10 },
            }}>
                <Divider style={{ marginBottom: 10 }} />
                <Typography variant="h3" component="h2" align="left" gutterBottom={true}>
                    Labourers - Manage labourer attendance and payment records
                </Typography>
                <Typography variant="body1" align="left">
                    Allowing to manage site Labourers Attendence smoothly
                </Typography>
                <br />
                <Slider {...settings}>
                    {imagesLabourerCarousal.map((image: any) => (
                        <ImageListItem>
                            <img
                                src={image}
                                alt={'test'}
                                loading="lazy"
                                style={{
                                    objectFit: 'contain',
                                }}
                            />
                        </ImageListItem>))
                    }
                </Slider>
            </Container>
        </Box>

        <Box id="contractor" sx={{
            pt: { xs: 4, sm: 12 },
            pb: { xs: 8, sm: 16 },
            color: 'white',
            bgcolor: 'grey.900',
        }}>
            <Container fixed className='slider-container' sx={{
                px: { sm: 15, xs: 10 },
            }}>
                <Divider style={{ marginBottom: 10 }} />
                <Typography variant="h3" component="h2" align="left" gutterBottom={true}>
                    Contractors - Manage all Third Party Contractors
                </Typography>
                <Typography variant="body1" align="left">
                    Allowing to borrow labourers from other contractors and manage payment records
                </Typography>
                <br />
                <Slider {...settings}>
                    {contractorCarousal.map((image: any) => (
                        <ImageListItem>
                            <img
                                src={image}
                                alt={'test'}
                                loading="lazy"
                                style={{
                                    objectFit: 'contain',
                                }}
                            />
                        </ImageListItem>))
                    }
                </Slider>
            </Container>
        </Box>
        <Box id="reporting" sx={{
            pt: { xs: 4, sm: 12 },
            pb: { xs: 8, sm: 16 },
            color: 'white',
            bgcolor: 'grey.900',
        }}>
            <Container fixed className='slider-container' sx={{
                px: { sm: 15, xs: 10 },
            }}>
                <Divider style={{ marginBottom: 10 }} />
                <Typography variant="h3" component="h2" align="left" gutterBottom={true}>
                    Reporting - Bird eye view of site workflow via reports
                </Typography>
                <Typography variant="body1" align="left">
                    Allowing to manage multiple sites smoothly via reporting
                </Typography>
                <br />
                <Slider {...settings}>
                    {reportingCarousal.map((image: any) => (
                        <ImageListItem>
                            <img
                                src={image}
                                alt={'test'}
                                loading="lazy"
                                style={{
                                    objectFit: 'contain',
                                }}
                            />
                        </ImageListItem>))
                    }
                </Slider>
            </Container>
        </Box>
        <Box id="access management" sx={{
            pt: { xs: 4, sm: 12 },
            pb: { xs: 8, sm: 16 },
            color: 'white',
            bgcolor: 'grey.900',
        }}>
            <Container fixed className='slider-container' sx={{
                px: { sm: 15, xs: 10 },
            }}>
                <Divider style={{ marginBottom: 10 }} />
                <Typography variant="h3" component="h2" align="left" gutterBottom={true}>
                    Group Access Managment - Manage your group users within the app
                </Typography>
                <Typography variant="body1" align="left">
                    Allowing to create/update and manage app users seamlessly
                </Typography>
                <br />
                <Slider {...settings}>
                    {adminCarousal.map((image: any) => (
                        <ImageListItem>
                            <img
                                src={image}
                                alt={'test'}
                                loading="lazy"
                                style={{
                                    objectFit: 'contain',
                                }}
                            />
                        </ImageListItem>))
                    }
                </Slider>
            </Container>
        </Box>
        <IOSAppModal />
        <ContactSalesModal />
        
        <Box id="contact" sx={{
            pt: { xs: 4, sm: 12 },
            pb: { xs: 8, sm: 16 },
            color: 'white',
            bgcolor: 'grey.800',
        }}>
            <Container fixed sx={{
                px: { sm: 15, xs: 10 },
            }}>
                <Divider style={{ marginBottom: 10 }} />
                <Typography variant="h4" component="h2" align="left" gutterBottom>
                    Contact & Support
                </Typography>
                <Typography variant="body1" align="left" gutterBottom>
                    For support or assistance with the SyteFlow app, please contact us at:
                </Typography>
                <Typography variant="body1" align="left" sx={{ fontWeight: 'bold' }}>
                    Email: <a href="mailto:contact@aliatis.io" style={{ color: 'lightblue' }}>contact@aliatis.io</a>
                </Typography>
                <Typography variant="body2" align="left" sx={{ mt: 2 }}>
                    Please include your username and a short description of the issue so we can assist you faster.
                </Typography>
            </Container>
        </Box>
    </div>);
};